
import React from 'react';
import { Box, Card, Divider, TableBody, Tooltip } from '@mui/material';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Sample from "../../AdminDashboard/Onsite And Offsite/Sample.json";
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import Paginator from "../../../toolkit/Paginator";
import Edit from "../../../icons/edit.svg";
import Trash from "../../../icons/trash1.svg";
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import { useState, useEffect } from 'react';
import { MenuItem } from "@mui/material";
import Select from "@mui/material/Select";
import FormControl from '@mui/material/FormControl';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import EditTemplate from './EditTemplate';
import axios from '../../../utils/fvAxios';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { ToastContainer, toast } from 'react-toastify';
import Nodata from "../../Nodata/Nodata";
import Delay from "../../../utils/Delayed";
import { HasScreenPermissions, HasPermissions } from '../../../utils/Token';
import INFO from '../../../pages/commom/RouteUrlInfo.json';
import PER from "../../../utils/Enums.json";

export default function EmailTemplates() {

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: theme.palette.action.hover,

        },
        [`&.${tableCellClasses.body}`]: {
            fontSize: 14,
        },
        // hide last border
        '&:last-child td, &:last-child th': {
            border: 0,
            marginBottom: "20px"
        },
    }));

    const toastNotify = (message, isSuccess = true) => {
        if (isSuccess) {
            toast.success(message, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        } else {
            toast.error(message, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
    };

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const [shows, setShow] = useState(true);
    const [spinner, setSpinner] = React.useState(false);
    const [Id, setId] = React.useState("");
    const [Details, setDetails] = React.useState("");
    const [LanguageList, setLanguageList] = React.useState([]);



    const OpenTab = async (num, info) => {
        setDetails(num != 1 ? info?.emailTemplateID : "");
        setId(num);
        setShow(false);
    }
    const CloseTab = () => {
        setShow(true)
        setTimeout(() => {
            window.scrollTo(0, 0);
        }, 50);
    }

    const [EmailTemplatesList, setEmailTemplatesList] = useState([]);

    useEffect(() => {
        GetEmailTemplatesList();
    }, []);

    const [Search, setSearch] = useState("");
    const [EmailTemList, setEmailTemList] = React.useState(false);
    function search(data) {
        let Records = data?.filter(s =>
            s?.name?.toLowerCase().includes(Search?.toLowerCase())
        );
        return Records;
    }

    useEffect(() => {
        setEmailTemList(search(EmailTemplatesList)?.length == 0 ? true : false);
    }, [EmailTemplatesList, Search]);

    const SpinnerClose = () => {
        setSpinner(false);
    };

    async function GetEmailTemplatesList() {
        setSpinner(!spinner);
        const res = await axios.get("EmailTemplates/GetEmailTemplatesList");
        setEmailTemplatesList(res?.data?.data?.localEmailTemplateListObj);
        setLanguageList(res?.data?.data?.languageList);
        setTimeout(() => {
            setSpinner(spinner);
        }, 80);

    }
    const [open, setOpen] = React.useState(false);
    const [DeleteTempId, setDeleteTempId] = React.useState("");

    const DialogOpenClick = (e) => {
        setDeleteTempId(e);
        setOpen(true);
    };
    const DialogCloseClick = () => {
        setOpen(false);
    };
    const Delete = async () => {
        const res = await axios.post("MyAccount/DeleteEmailTemplate?templateId=" + DeleteTempId);
        if (res?.data?.responseCode == 100) {
            toastNotify(res?.data?.data, true);
            setOpen(false);
            GetEmailTemplatesList();
        } else {
            toastNotify(res?.data?.responseMessage, false);
            setOpen(false);
        }

    }
    const StyledTooltip = styled(({ className, ...props }) => (
        <Tooltip {...props} classes={{ popper: className }} />
    ))`
        & .MuiTooltip-tooltip {
          background:  rgba(97, 97, 97, 0.92)!important;
          color:#fff !important
        }
           & .MuiTooltip-arrow: {
          color: rgba(97, 97, 97, 0.92)!important;
        }
      `;
    return (
        <>
            <ToastContainer />
            {shows ?
                (<div style={{ display: shows ? "block" : "none" }}>
                    <Dialog fullScreen={fullScreen} open={open} onClose={DialogCloseClick}>
                        <DialogContent sx={{ padding: "48px 48px" }} >
                            <DialogTitle
                                sx={{
                                    textAlign: "center",
                                    fontWeight: 500,
                                    fontSize: 20,
                                }}
                            >
                                <span style={{ fontSize: "larger" }} >Delete template</span>
                            </DialogTitle>

                            <DialogActions >
                                <div>
                                    <DialogActions >
                                        <div>
                                            {"Are you sure, you want to delete the template?"}

                                            <DialogActions >
                                                <div className="login-help__buttonContainer mt-4">
                                                    <Button variant="contained" className="login-help-button-cancel mx-2" onClick={DialogCloseClick}>Cancel</Button>
                                                    <Button variant="contained" className="login-button-request mx-2" onClick={Delete}> ok</Button>
                                                </div>

                                            </DialogActions>
                                        </div >
                                    </DialogActions>
                                </div>
                            </DialogActions>
                        </DialogContent>

                    </Dialog>
                    <Delay waitBeforeShow={500}>
                        <Card>

                            <Backdrop
                                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                                open={spinner}
                                onClick={SpinnerClose}
                            >
                                <CircularProgress color="inherit" />
                            </Backdrop>
                            <div style={{ marginLeft: "10px", marginTop: "10px" }}>
                                <div style={{ marginLeft: "15px", marginBottom: "15px" }}>
                                    <Stack spacing={2} direction="row">
                                        <h2> Email Templates List</h2>
                                        <div style={{ marginLeft: "Auto", padding: "10px" }}>
                                            {!HasScreenPermissions(INFO?.AddOrEditEmailTemplate?.actionName) &&
                                                <Button variant="contained" sx={{ padding: "inherit" }} onClick={() => OpenTab(1, "")} >+ Add New</Button>
                                            }
                                        </div>
                                    </Stack >
                                </div>
                            </div>
                            <Divider sx={{ marginTop: 2, marginBottom: 2, backgroundColor: "#667085;", height: "2px" }} />
                            <div style={{ marginLeft: "15px", marginBottom: "15px" }}>
                                <TextField size='small' placeholder='Search...' sx={{ width: "320px" }} value={Search} onChange={(e) => setSearch(e.target.value)} />
                            </div>
                            {EmailTemList == true ? <div hidden={spinner}><Nodata /> </div> : <>
                                <Box sx={{ backgroundColor: '#f8f9fa' }}>

                                    <TableContainer component={Paper} sx={{ borderBottom: 0 }}>
                                        <Table aria-label="customized table">
                                            <TableHead>
                                                <TableRow>
                                                    <StyledTableCell ><span style={{ color: "#667085", fontSize: "16px" }}> Template Name</span></StyledTableCell>
                                                    <StyledTableCell >&nbsp;</StyledTableCell>
                                                    <StyledTableCell >&nbsp;</StyledTableCell>
                                                    <StyledTableCell >&nbsp;</StyledTableCell>

                                                </TableRow>
                                            </TableHead>
                                            {search(EmailTemplatesList)?.map((r, i) => (
                                                <TableBody key={i}>
                                                    <TableRow key={i} >
                                                        <StyledTableCell sx={{ width: "80%" }}>
                                                            {r?.name}
                                                        </StyledTableCell>
                                                        <StyledTableCell sx={{ width: "15%" }} >
                                                            {HasPermissions(INFO?.AddOrEditEmailTemplate?.actionName, "R") ?
                                                                <a style={{ textDecoration: "none", color: "blue", cursor: "pointer" }} onClick={() => OpenTab(3, r)}>Setup language content</a>
                                                                : <Tooltip title={"You don't have a permission"} followCursor>
                                                                    <span style={{ cursor: "pointer" }}>Setup language content</span>
                                                                </Tooltip>
                                                            }
                                                        </StyledTableCell>
                                                        <StyledTableCell sx={{ width: "10%" }} >
                                                            {HasPermissions(INFO?.AddOrEditEmailTemplate?.actionName, "R") &&
                                                                <IconButton aria-label="edit" onClick={() => OpenTab(2, r)}>
                                                                    <img src={Edit} alt="editicon" />
                                                                </IconButton>
                                                            }
                                                        </StyledTableCell>
                                                        <StyledTableCell sx={{ width: "5%" }}>
                                                            {(HasPermissions(INFO?.EmailTemplatesList?.actionName, PER?.ScreenPermissions?.Delete) && HasPermissions(INFO?.AddOrEditEmailTemplate?.actionName, PER?.ScreenPermissions?.Delete)) &&
                                                                <IconButton aria-label="delete" onClick={() => DialogOpenClick(r?.emailTemplateID)}>
                                                                    <img src={Trash} alt="trashicon" />
                                                                </IconButton>
                                                            }
                                                        </StyledTableCell>

                                                    </TableRow>

                                                </TableBody>
                                            ))}
                                        </Table>

                                    </TableContainer>
                                </Box >
                            </>}

                        </Card>
                    </Delay>

                    {/* <Paginator
                    count={Math.ceil(Sample.length / 10)}
                    page={Number(1)}
                    margin="18px 0px"
                    onChange={() => 1}
                /> */}
                </div>)
                :
                (
                    <Delay waitBeforeShow={100}>
                        <div style={{ display: shows ? "none" : "block" }}>
                            <EditTemplate OpenTab={OpenTab} CLOSETAB={CloseTab} DETAILS={Details} SHOWS={shows} ID={Id} TemplatesList={GetEmailTemplatesList} Languages={LanguageList} />
                        </div>
                    </Delay>
                )
            }
        </>
    )
}



